"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-eleven/sections/aboutSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type AboutSection1sItem = {
    key: Key | null | undefined;
    /** Detected variants: "Experience" | "Challenge" */
    spanText: ReactNode;
    /** Detected variants: "text-1" */
    className?: string;
};
export type HomeElevenAboutSectionGeneratedProps = {
    sectionDiv0Div0ClassName?: string;
    /** Default: "1s" */
    sectionDiv0Div0Div0Div0DivDataWowDuration?: string;
    /** Default: "about-img" */
    sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/about/about-eleven-1.png" */
    sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "all_routes.booking" */
    sectionDiv0Div0Div0Div0Div0Link0LinkHref?: string;
    sectionDiv0Div0Div0Div0Div0Link0LinkVisible?: boolean;
    sectionDiv0Div0Div0Div0Div0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "Cosmetics ! surgeries " */
    sectionDiv0Div0Div0Div0Div0Link0Button0ButtonDataText?: string;
    sectionDiv0Div0Div0Div0Div0Link0Button0ButtonVisible?: boolean;
    sectionDiv0Div0Div0Div0Div0Link0Button0ButtonRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0Div0Link0Button0ButtonProps?: Partial<ComponentProps<"button">>;
    /** Default: "12+" */
    sectionDiv0Div0Div0Div0Div1Div0Div0Span0SpanText?: ReactNode;
    /** Default: "about-img" */
    sectionDiv0Div0Div0Div0Div1ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/about/about-eleven-2.png" */
    sectionDiv0Div0Div0Div0Div1ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div0Div0Div1ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div0Div0Div1ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0Div1ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "2s" */
    sectionDiv0Div0Div1Div0DivDataWowDuration?: string;
    /** Default: "About Us" */
    sectionDiv0Div0Div1Div0Div0Div0DivText?: ReactNode;
    /** Default: "arrow" */
    sectionDiv0Div0Div1Div0Div0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/arrow-left.svg" */
    sectionDiv0Div0Div1Div0Div0Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div1Div0Div0Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div1Div0Div0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "arrow" */
    sectionDiv0Div0Div1Div0Div0Div0ImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/arrow-right.svg" */
    sectionDiv0Div0Div1Div0Div0Div0ImageWithBasePath1ImageSrc?: string;
    sectionDiv0Div0Div1Div0Div0Div0ImageWithBasePath1ImageVisible?: boolean;
    sectionDiv0Div0Div1Div0Div0Div0ImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0Div0Div0ImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "Redefining Beauty Through" */
    sectionDiv0Div0Div1Div0Div0H20H2Text?: ReactNode;
    /** Default: "Precision" */
    sectionDiv0Div0Div1Div0Div0H20H2Text2?: ReactNode;
    sectionDiv0Div0Div1Div0Div0H20H2Visible?: boolean;
    sectionDiv0Div0Div1Div0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: 2025 */
    sectionDiv0Div0Div1Div0Div1Div0DivText?: ReactNode;
    /** Default: "icon" */
    sectionDiv0Div0Div1Div0Div2Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/about-icon-11.svg" */
    sectionDiv0Div0Div1Div0Div2Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div1Div0Div2Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div1Div0Div2Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0Div2Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "We provide personalized cosmetic solutions crafted with skill, innovation, and artistry. Every treatment is designed to enhance your natural features while keeping safety and comfort at the forefront." */
    sectionDiv0Div0Div1Div0Div2Div1DivText?: ReactNode;
    /** Default: "Our Mission" */
    sectionDiv0Div0Div1Div0Div3Div0H30H3Text?: ReactNode;
    sectionDiv0Div0Div1Div0Div3Div0H30H3Visible?: boolean;
    sectionDiv0Div0Div1Div0Div3Div0H30H3Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0Div3Div0H30H3Props?: Partial<ComponentProps<"h3">>;
    /** Default: "To enhance natural beauty with safe, advanced cosmetic empowers confidence in everyone." */
    sectionDiv0Div0Div1Div0Div3Div0P0PText?: ReactNode;
    /** Default: "Our Vision" */
    sectionDiv0Div0Div1Div0Div3Div1H30H3Text?: ReactNode;
    sectionDiv0Div0Div1Div0Div3Div1H30H3Visible?: boolean;
    sectionDiv0Div0Div1Div0Div3Div1H30H3Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0Div3Div1H30H3Props?: Partial<ComponentProps<"h3">>;
    /** Default: "Leading aesthetic innovation with trusted, transformative exceptional cosmetic excellence." */
    sectionDiv0Div0Div1Div0Div3Div1P0PText?: ReactNode;
    /** Default: "#" */
    sectionDiv0Div0Div1Div0Div4Link0LinkHref?: string;
    /** Default: "More About Us" */
    sectionDiv0Div0Div1Div0Div4Link0LinkText?: ReactNode;
    sectionDiv0Div0Div1Div0Div4Link0LinkVisible?: boolean;
    sectionDiv0Div0Div1Div0Div4Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0Div4Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "ABOUT US" */
    sectionDiv1DivText?: ReactNode;
    aboutSection1s: AboutSection1sItem[];
    aboutSection1sItemWrapper?: (item: AboutSection1sItem, content: ReactNode) => ReactNode;
    aboutSection1sRenderer?: (defaultNode: ReactNode) => ReactNode;
};

const HomeElevenAboutSectionGenerated: FC<HomeElevenAboutSectionGeneratedProps> = ({
    sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageAlt = "about-img",
    sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/about/about-eleven-1.png",
    sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div0Div0Div0Div0Link0Button0ButtonDataText = "Cosmetics ! surgeries ",
    sectionDiv0Div0Div0Div0Div0Link0Button0ButtonVisible,
    sectionDiv0Div0Div0Div0Div0Link0Button0ButtonRenderer,
    sectionDiv0Div0Div0Div0Div0Link0Button0ButtonProps,
    sectionDiv0Div0Div0Div0Div0Link0LinkHref = "all_routes.booking",
    sectionDiv0Div0Div0Div0Div0Link0LinkVisible,
    sectionDiv0Div0Div0Div0Div0Link0LinkRenderer,
    sectionDiv0Div0Div0Div0Div0Link0LinkProps,
    sectionDiv0Div0Div0Div0Div1Div0Div0Span0SpanText = "12+",
    sectionDiv0Div0Div0Div0Div1ImageWithBasePath0ImageAlt = "about-img",
    sectionDiv0Div0Div0Div0Div1ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/about/about-eleven-2.png",
    sectionDiv0Div0Div0Div0Div1ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div0Div0Div1ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div0Div0Div1ImageWithBasePath0ImageProps,
    sectionDiv0Div0Div0Div0DivDataWowDuration = "1s",
    sectionDiv0Div0Div1Div0Div0Div0DivText = "About Us",
    sectionDiv0Div0Div1Div0Div0Div0ImageWithBasePath0ImageAlt = "arrow",
    sectionDiv0Div0Div1Div0Div0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/icons/arrow-left.svg",
    sectionDiv0Div0Div1Div0Div0Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div1Div0Div0Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div1Div0Div0Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div0Div1Div0Div0Div0ImageWithBasePath1ImageAlt = "arrow",
    sectionDiv0Div0Div1Div0Div0Div0ImageWithBasePath1ImageSrc = "/Templates/Doccure/img/icons/arrow-right.svg",
    sectionDiv0Div0Div1Div0Div0Div0ImageWithBasePath1ImageVisible,
    sectionDiv0Div0Div1Div0Div0Div0ImageWithBasePath1ImageRenderer,
    sectionDiv0Div0Div1Div0Div0Div0ImageWithBasePath1ImageProps,
    sectionDiv0Div0Div1Div0Div0H20H2Text = "Redefining Beauty Through",
    sectionDiv0Div0Div1Div0Div0H20H2Text2 = "Precision",
    sectionDiv0Div0Div1Div0Div0H20H2Visible,
    sectionDiv0Div0Div1Div0Div0H20H2Renderer,
    sectionDiv0Div0Div1Div0Div0H20H2Props,
    sectionDiv0Div0Div1Div0Div1Div0DivText = 2025,
    sectionDiv0Div0Div1Div0Div2Div0ImageWithBasePath0ImageAlt = "icon",
    sectionDiv0Div0Div1Div0Div2Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/icons/about-icon-11.svg",
    sectionDiv0Div0Div1Div0Div2Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div1Div0Div2Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div1Div0Div2Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div0Div1Div0Div2Div1DivText = "We provide personalized cosmetic solutions crafted with skill, innovation, and artistry. Every treatment is designed to enhance your natural features while keeping safety and comfort at the forefront.",
    sectionDiv0Div0Div1Div0Div3Div0H30H3Text = "Our Mission",
    sectionDiv0Div0Div1Div0Div3Div0H30H3Visible,
    sectionDiv0Div0Div1Div0Div3Div0H30H3Renderer,
    sectionDiv0Div0Div1Div0Div3Div0H30H3Props,
    sectionDiv0Div0Div1Div0Div3Div0P0PText = "To enhance natural beauty with safe, advanced cosmetic empowers confidence in everyone.",
    sectionDiv0Div0Div1Div0Div3Div1H30H3Text = "Our Vision",
    sectionDiv0Div0Div1Div0Div3Div1H30H3Visible,
    sectionDiv0Div0Div1Div0Div3Div1H30H3Renderer,
    sectionDiv0Div0Div1Div0Div3Div1H30H3Props,
    sectionDiv0Div0Div1Div0Div3Div1P0PText = "Leading aesthetic innovation with trusted, transformative exceptional cosmetic excellence.",
    sectionDiv0Div0Div1Div0Div4Link0LinkHref = "#",
    sectionDiv0Div0Div1Div0Div4Link0LinkText = "More About Us",
    sectionDiv0Div0Div1Div0Div4Link0LinkVisible,
    sectionDiv0Div0Div1Div0Div4Link0LinkRenderer,
    sectionDiv0Div0Div1Div0Div4Link0LinkProps,
    sectionDiv0Div0Div1Div0DivDataWowDuration = "2s",
    sectionDiv1DivText = "ABOUT US",
    sectionDiv0Div0ClassName,
    aboutSection1s,
    aboutSection1sItemWrapper,
    aboutSection1sRenderer,
}) => {
    return (
        <section className="about-section-eleven section overflow-hidden">
            <div className="container">
                <div className={sectionDiv0Div0ClassName ?? "row align-items-center"}>
                    <div className="col-lg-6">
                        <div className="about-img-eleven wow fadeInUp" data-wow-duration={sectionDiv0Div0Div0Div0DivDataWowDuration}>
                            <div className="about-img-left">
                                {renderNode(sectionDiv0Div0Div0Div0Div0Link0LinkVisible, sectionDiv0Div0Div0Div0Div0Link0LinkRenderer, (
                                    <SmartLink href={sectionDiv0Div0Div0Div0Div0Link0LinkHref} {...(sectionDiv0Div0Div0Div0Div0Link0LinkProps ?? {})}>
                                        {renderNode(sectionDiv0Div0Div0Div0Div0Link0Button0ButtonVisible, sectionDiv0Div0Div0Div0Div0Link0Button0ButtonRenderer, (
                                            <button className="animate-button" data-text={sectionDiv0Div0Div0Div0Div0Link0Button0ButtonDataText} {...(sectionDiv0Div0Div0Div0Div0Link0Button0ButtonProps ?? {})}>
                                                <p className="button-text" />
                                                <span className="button-circle">
                                                    <i className="isax isax-arrow-right-1" />
                                                </span>
                                            </button>
                                        ))}
                                    </SmartLink>
                                ))}
                                {renderNode(sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageVisible, sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageRenderer, (
                                    <SmartImage src={sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageAlt} className="img-fluid img-1" {...(sectionDiv0Div0Div0Div0Div0ImageWithBasePath0ImageProps ?? {})} />
                                ))}
                            </div>
                            <div className="about-img-right">
                                {renderNode(sectionDiv0Div0Div0Div0Div1ImageWithBasePath0ImageVisible, sectionDiv0Div0Div0Div0Div1ImageWithBasePath0ImageRenderer, (
                                    <SmartImage src={sectionDiv0Div0Div0Div0Div1ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div0Div0Div1ImageWithBasePath0ImageAlt} className="img-fluid img-2" {...(sectionDiv0Div0Div0Div0Div1ImageWithBasePath0ImageProps ?? {})} />
                                ))}
                                <div className="experience">
                                    <div className="count">
                                        {" "}
                                        <span>{sectionDiv0Div0Div0Div0Div1Div0Div0Span0SpanText}</span>
                                    </div>
                                    <div className="text">
                                        {renderCollectionNode(
                                            aboutSection1s,
                                            (item: AboutSection1sItem) => (
                                                <span className={item.className} key={item.key}>{item.spanText}</span>
                                            ),
                                            aboutSection1sItemWrapper,
                                            aboutSection1sRenderer
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="about-right-eleven wow fadeInUp" data-wow-duration={sectionDiv0Div0Div1Div0DivDataWowDuration}>
                            <div className="section-header section-header-eleven">
                                <div className="title">
                                    {renderNode(sectionDiv0Div0Div1Div0Div0Div0ImageWithBasePath0ImageVisible, sectionDiv0Div0Div1Div0Div0Div0ImageWithBasePath0ImageRenderer, (
                                        <SmartImage src={sectionDiv0Div0Div1Div0Div0Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div1Div0Div0Div0ImageWithBasePath0ImageAlt} className="img-fluid icon-1" {...(sectionDiv0Div0Div1Div0Div0Div0ImageWithBasePath0ImageProps ?? {})} />
                                    ))}
                                    {sectionDiv0Div0Div1Div0Div0Div0DivText}
                                    {renderNode(sectionDiv0Div0Div1Div0Div0Div0ImageWithBasePath1ImageVisible, sectionDiv0Div0Div1Div0Div0Div0ImageWithBasePath1ImageRenderer, (
                                        <SmartImage src={sectionDiv0Div0Div1Div0Div0Div0ImageWithBasePath1ImageSrc} alt={sectionDiv0Div0Div1Div0Div0Div0ImageWithBasePath1ImageAlt} className="img-fluid icon-2" {...(sectionDiv0Div0Div1Div0Div0Div0ImageWithBasePath1ImageProps ?? {})} />
                                    ))}
                                </div>
                                {renderNode(sectionDiv0Div0Div1Div0Div0H20H2Visible, sectionDiv0Div0Div1Div0Div0H20H2Renderer, (
                                    <h2 className="section-title" {...(sectionDiv0Div0Div1Div0Div0H20H2Props ?? {})}>
                                        {" "}
                                        {sectionDiv0Div0Div1Div0Div0H20H2Text}
                                        <br />
                                        {sectionDiv0Div0Div1Div0Div0H20H2Text2}
                                        {" "}
                                    </h2>
                                ))}
                            </div>
                            <div className="about-year">
                                <div className="year">{sectionDiv0Div0Div1Div0Div1Div0DivText}</div>
                            </div>
                            <div className="about-content">
                                <div className="about-icon">
                                    {renderNode(sectionDiv0Div0Div1Div0Div2Div0ImageWithBasePath0ImageVisible, sectionDiv0Div0Div1Div0Div2Div0ImageWithBasePath0ImageRenderer, (
                                        <SmartImage src={sectionDiv0Div0Div1Div0Div2Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div1Div0Div2Div0ImageWithBasePath0ImageAlt} className="img-fluid img-1" {...(sectionDiv0Div0Div1Div0Div2Div0ImageWithBasePath0ImageProps ?? {})} />
                                    ))}
                                </div>
                                <div className="about-text">{sectionDiv0Div0Div1Div0Div2Div1DivText}</div>
                            </div>
                            <div className="about-details">
                                <div className="about-item-eleven one">
                                    {renderNode(sectionDiv0Div0Div1Div0Div3Div0H30H3Visible, sectionDiv0Div0Div1Div0Div3Div0H30H3Renderer, (
                                        <h3 className="custom-title" {...(sectionDiv0Div0Div1Div0Div3Div0H30H3Props ?? {})}>{sectionDiv0Div0Div1Div0Div3Div0H30H3Text}</h3>
                                    ))}
                                    <p>{sectionDiv0Div0Div1Div0Div3Div0P0PText}</p>
                                </div>
                                <div className="about-item-eleven">
                                    {renderNode(sectionDiv0Div0Div1Div0Div3Div1H30H3Visible, sectionDiv0Div0Div1Div0Div3Div1H30H3Renderer, (
                                        <h3 className="custom-title" {...(sectionDiv0Div0Div1Div0Div3Div1H30H3Props ?? {})}>{sectionDiv0Div0Div1Div0Div3Div1H30H3Text}</h3>
                                    ))}
                                    <p>{sectionDiv0Div0Div1Div0Div3Div1P0PText}</p>
                                </div>
                            </div>
                            <div className="view-all">
                                {renderNode(sectionDiv0Div0Div1Div0Div4Link0LinkVisible, sectionDiv0Div0Div1Div0Div4Link0LinkRenderer, (
                                    <SmartLink href={sectionDiv0Div0Div1Div0Div4Link0LinkHref} className="btn btn-primary" {...(sectionDiv0Div0Div1Div0Div4Link0LinkProps ?? {})}>
                                        {sectionDiv0Div0Div1Div0Div4Link0LinkText}
                                        <i className="isax isax-arrow-right-3" />
                                    </SmartLink>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="animate-text">{sectionDiv1DivText}</div>
        </section>
    );
};

export default HomeElevenAboutSectionGenerated;
